import { ChipSelect } from 'Components/ChipSelect/ChipSelect'

export default ChipSelect
